// extracted by mini-css-extract-plugin
export var avatar = "_rg-3";
export var avatarContainer = "_rg-2";
export var avatarSpacer = "_rg-5";
export var avatarSpacerContainer = "_rg-4";
export var avatarStackContainer = "_rg-1";
export var bubble = "_rg-0";
export var remainderBubble = "_rg-6";